/**
 * Sidebar module icons for notifications - kept in sync with
 * `src/app/mock-api/common/navigation/data.ts` and `resolveNotificationRoute`.
 */
export interface NotificationModuleIconStyle
{
    icon: string;
    bg: string;
    text: string;
}

/** Token-driven badge chrome (flips light/dark via --sai-* tokens). */
const BADGE_BG = 'sai-notifications-panel__icon-badge';
const BADGE_GLYPH = 'sai-notifications-panel__icon-badge-glyph';

/** Normalized notification tag → sidebar nav icon */
const NOTIFICATION_MODULE_ICONS: Record<string, NotificationModuleIconStyle> = {
    data_source: {
        icon: 'heroicons_outline:square-3-stack-3d',
        bg: BADGE_BG,
        text: BADGE_GLYPH,
    },
    question: {
        icon: 'heroicons_outline:clipboard-document-check',
        bg: BADGE_BG,
        text: BADGE_GLYPH,
    },
    report: {
        icon: 'heroicons_outline:paper-airplane',
        bg: BADGE_BG,
        text: BADGE_GLYPH,
    },
    team_task: {
        icon: 'heroicons_outline:check-circle',
        bg: BADGE_BG,
        text: BADGE_GLYPH,
    },
    ai_chat_share: {
        icon: 'heroicons_outline:chat-bubble-left-right',
        bg: BADGE_BG,
        text: BADGE_GLYPH,
    },
    automation_delivery: {
        icon: 'heroicons_outline:chat-bubble-left-right',
        bg: BADGE_BG,
        text: BADGE_GLYPH,
    },
    automation: {
        icon: 'heroicons_outline:bolt',
        bg: BADGE_BG,
        text: BADGE_GLYPH,
    },
    procedure: {
        icon: 'heroicons_outline:cube-transparent',
        bg: BADGE_BG,
        text: BADGE_GLYPH,
    },
    favorites_shared: {
        icon: 'heroicons_outline:view-columns',
        bg: BADGE_BG,
        text: BADGE_GLYPH,
    },
    crm_catalogue: {
        icon: 'heroicons_outline:shopping-bag',
        bg: BADGE_BG,
        text: BADGE_GLYPH,
    },
};

const DEFAULT_NOTIFICATION_MODULE_ICON: NotificationModuleIconStyle = {
    icon: 'heroicons_outline:bell',
    bg: BADGE_BG,
    text: BADGE_GLYPH,
};

export function getNotificationModuleIcon(normalizedTag: string): NotificationModuleIconStyle
{
    return NOTIFICATION_MODULE_ICONS[normalizedTag] ?? DEFAULT_NOTIFICATION_MODULE_ICON;
}
